import { Component } from 'react';

import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';

import { ApplicationState } from '@mews-commander/types';
import { getCurrentUserMenuAccount } from '../selectors';
import UserMenuAvatar from './UserMenuAvatar';
import { ProfileBackground, ProfileImageBackground, ProfileContainer, UserName, AccountName } from './styles';
import { WithActiveAccount } from './types';

interface BackgroundComponentProps {
    loginScreenImage: string;
}

const BackgroundComponent: React.FC<React.PropsWithChildren<BackgroundComponentProps>> = ({
    loginScreenImage,
    children,
}) =>
    loginScreenImage ? (
        <ProfileImageBackground src={loginScreenImage}>{children}</ProfileImageBackground>
    ) : (
        <ProfileBackground>{children}</ProfileBackground>
    );

class ProfileCard extends Component<WithActiveAccount> {
    render() {
        const { activeAccount } = this.props;
        const { loginScreenImage, fullName, displayName } = activeAccount;

        return (
            <BackgroundComponent loginScreenImage={loginScreenImage}>
                <ProfileContainer>
                    <UserMenuAvatar />
                    <AccountName>
                        <UserName>{fullName}</UserName>
                        {displayName}
                    </AccountName>
                </ProfileContainer>
            </BackgroundComponent>
        );
    }
}

type StateProps = WithActiveAccount;

export default connect<StateProps, {}, {}, ApplicationState>(
    createStructuredSelector<ApplicationState, StateProps>({
        // @ts-expect-error $TSFixMeError: Type 'OutputSelector<ApplicationState, { enterpriseId: { toString: ...; charAt: ...; charCodeAt: ...; concat: ...; index...
        activeAccount: getCurrentUserMenuAccount,
    })
)(ProfileCard);
